import { ALLOWED_IMAGESERVER_HOSTNAMES } from '#shared/allowed-imageserver-hostnames';
import { resize } from '#utils/image/resize';

type Image = {
	altText?: string | null;
};

type GetImageAltTextInput = {
	image?: Image | null;
	seoTitle?: string | null;
	title: string;
};

export function getImageAltText({ image, seoTitle, title }: GetImageAltTextInput): string {
	return image?.altText || seoTitle || title;
}

export function getImageCopyright(image: { copyright?: string | null } | null | undefined) {
	return image?.copyright ?? null;
}

function isImageServerImage(url: string) {
	return ALLOWED_IMAGESERVER_HOSTNAMES.has(new URL(url).hostname);
}

export function getImageUrl(image: { url?: string | null } | null | undefined, options?: { dontResize?: boolean }): string | undefined {
	const { url } = image || {};

	if (!url || options?.dontResize || !isImageServerImage(url)) {
		return url ?? undefined;
	}

	return resize(url, 'landscape', 'xxl');
}
